export class MaintenanceStrategyBoundary {
  id: string;
  text: string;
  maintenanceStrategyId: string;

  loadFromJson(data: any) {
    this.id = data.id;
    this.text = data.text;
    this.maintenanceStrategyId = data.maintenanceStrategyId;
  }
}
